import React, { memo, useState } from 'react';
import useGlobalState from '@hooks/useGlobalState';
import useMyHeartItem from '@hooks/useMyHeartItem';
import useRenderProducts from '@hooks/useRenderProducts';
import { EventProduct } from '@wconcept/wconcept-common/models/event/custom';
import useGa4Event from '@hooks/useGa4Event';
import useBrazeLogger from '@hooks/useBrazeLogger';
import useMolocoLogger from '@hooks/useMolocoLogger';
import type { PromotionModuleVisualTokens } from '@utils/promotionContentVisual';
import { RankingModule } from './RankingModule';

interface CategoryItem {
  categoryName: string;
  displayCategoryName: string;
  key: string;
  mediumName: string;
}

interface RankingModuleContainerProps {
  bgType: string;
  visualTokens: PromotionModuleVisualTokens;
  isDesktop: boolean;
  categoryList: CategoryItem[];
  title?: string;
  promotionId?: number;
  subTitle?: string;
  updateTime: string;
  order: number;
  registerModule?: (contentId: string, element: HTMLElement | null) => void;
  contentId?: string;
}

export function RankingModuleContainer({
  bgType,
  visualTokens,
  isDesktop,
  categoryList,
  subTitle,
  title,
  updateTime,
  order,
  registerModule,
  contentId,
  promotionId,
}: RankingModuleContainerProps) {
  const { assistData } = useGlobalState();
  const [selectedTab, setSelectedTab] = useState<CategoryItem | null>(
    categoryList[0]
  );
  // const { onClickHeart } = useMyHeartItem({
  //   isLogin: !!assistData?.isLogin,
  // });
  const { sendGa4AddToWishProduct, sendGa4SelectItem } = useGa4Event();
  const { sendMolocoAddToWish } = useMolocoLogger();
  const { sendBrazeRenewalMyHeart } = useBrazeLogger();
  const { renderEventProducts } = useRenderProducts({
    doAfterAddMyHeart: (product, index) => {
      sendGa4AddToWishProduct({
        product,
        myheartYn: true,
        listNo: (index ?? 0) + 1,
        ecommercePath: '프로모션',
        page: 'promotion',
        area: 'promotion_ranking_myheart',
        issueCd: promotionId?.toString(),
        issueNm: title,
        tabNm: selectedTab?.displayCategoryName,
      });
      sendMolocoAddToWish({
        itemCd: product.itemCd,
        amount: product.finalPrice,
        pageId: window.location.pathname,
      });
      sendBrazeRenewalMyHeart({
        product,
        pageId: window.location.pathname,
        useGender: true,
        defaultGender: 'women',
      });
      // onClickHeart?.(product, true, index || 0);
    },
    doAfterDeleteMyHeart: (product, index) => {
      sendGa4AddToWishProduct({
        product,
        myheartYn: false,
        listNo: (index ?? 0) + 1,
        ecommercePath: '프로모션',
        page: 'promotion',
        area: 'promotion_ranking_myheart',
        issueCd: promotionId?.toString(),
        issueNm: title,
        tabNm: selectedTab?.displayCategoryName,
      });
      // onClickHeart?.(product, false, index || 0);
    },
  });

  // const handleHeartClick = (
  //   product: EventProduct,
  //   isAdd: boolean,
  //   index: number
  // ) => {
  //   onClickHeart?.(product, isAdd, index);
  // };

  return (
    <RankingModule
      bgType={bgType}
      visualTokens={visualTokens}
      isDesktop={isDesktop}
      categoryList={categoryList}
      rankCateTab={categoryList[0]}
      subTitle={subTitle}
      title={title}
      order={order}
      promotionTitle={title}
      // onHeartClick={handleHeartClick}
      renderProducts={renderEventProducts}
      registerModule={registerModule}
      contentId={contentId}
      promotionId={promotionId}
      selectedTab={selectedTab}
      setSelectedTab={setSelectedTab}
    />
  );
}

export default memo(RankingModuleContainer);
